import { isNil } from "client/Misc/utils";
import { ExchangeEmailId } from "client/Api/Email/common";
import { EmailResponseKind } from "./EmailPage/EmailPage";

export enum EmailHistoryStateKind {
	DraftPage = "34969521-34d2-4f8b-8bff-a7f90ea2a074"
};

export type EmailResponseHistoryState = {
	kind: EmailResponseKind;
	originalEmailId: ExchangeEmailId;
};

export type DraftPageHistoryState = {
	kind: EmailHistoryStateKind.DraftPage;
	response?: EmailResponseHistoryState;
};

export function isDraftPageHistoryState(state: unknown): state is DraftPageHistoryState {
	if (isNil(state)) {
		return false;
	}
	if (typeof state !== "object") {
		return false;
	}

	return (state as DraftPageHistoryState).kind === EmailHistoryStateKind.DraftPage;
}